import { useEffect, useState, useRef } from "react";
import { getCompletedEvents } from "../../utils/API/user";
import ChallengeCompletedRating from "../ChallengeCompletedRating";
import ChallengeFinalizeButton from "../ChallengeFinalizeButton";
import ChallengeTimelineBar from "../ChallengeTimelineBar";
import PageTitle from "../PageTitle";
import TopMenu from "../TopMenu";
import ColleaguesList from "../ColleaguesList";

import "./styles.css";
import { setNotification } from "../../utils/Notifications";
import { LogOut } from "../../utils/API/auth";
import { ChallengeNotification } from "../StaticNotification";
import ScrollContent from "../ScrollContent";
import LearnContentElement from "../LearnContentElement";
import CustomButton from "../Buttons";
import { useNotifications } from "../../utils/NotificationContext";
import { getLearningArticles } from "../../utils/API/learn";
import CustomLink from "../../utils/customLink";
import useCustomNavigate from "../../utils/CustomNavigate";
const ChallengeElement = ({
  challenge,
  onChallengeCompleted,
  buttonLoading,
  colleaguesAlsoCompleted,
  notification,
  onNotificationClose,
  notificationClosing,
  showAnimation,
  onAnimationPresentClicked,
}) => {
  const navigator = useCustomNavigate();
  const [videoCompleted, setVideoCompleted] = useState(!challenge.media);

  const handleSettingsClick = () => {
    navigator("/challenge/settings", {
      state: {
        challengeID: challenge.event_id,
      },
    });
  };

  const handleVideoComplete = () => {
    setVideoCompleted(true);
  };

  const showSettings =
    !showAnimation && (notification === 0 || notificationClosing);

  const showNotification = !showAnimation && notification !== 0;

  const addHasNotification =
    notification !== 0 && !notificationClosing && !showAnimation;

  const [animationPresentClicked, setAnimationPresentClicked] = useState(false);

  const [addAnimationClassToChallenge] = useState(showAnimation);

  return (
    <>
      {showSettings ? (
        <div
          className={`absolute challenge-settings no-bg ${
            notificationClosing ? "appearing" : ""
          } `}
          onClick={handleSettingsClick}
        >
          <img src="/assets/images/settings.svg" alt="Settings bar" />
        </div>
      ) : null}

      {showNotification ? (
        <ChallengeNotification
          notification={notification}
          onNotificationClose={onNotificationClose}
          notificationClosing={notificationClosing}
        />
      ) : null}

      <div
        className={`absolute challenge-wrapper no-bg ${
          addHasNotification ? "has_notification" : ""
        }`}
      >
        <ChallengeTimelineBar
          minutesLeft={challenge.timeLeft}
          className={addHasNotification ? "has_notification" : ""}
        />

        {showAnimation ? (
          <div
            className={`absolute challenge-animation-wrapper no-bg ${
              animationPresentClicked ? "fading" : "shaking"
            }
            `}
            onClick={() => {
              setAnimationPresentClicked(true);
              onAnimationPresentClicked();
            }}
          >
            <img
              className="top"
              src="/assets/images/animation-present/cadou_top.svg"
              alt=""
            />
            <img
              className="base"
              src="/assets/images/animation-present/cadou_baza.svg"
              alt=""
            />
            <img
              className="hidden"
              src="/assets/images/animation-present/cerc_dark.svg"
              alt=""
            />
            <img
              className="hidden"
              src="/assets/images/animation-present/cerc_dark.svg"
              alt=""
            />
            <img
              className="hidden"
              src="/assets/images/animation-present/cerc.svg"
              alt=""
            />
            <img
              className="hidden"
              src="/assets/images/animation-present/cerc.svg"
              alt=""
            />
            <img
              className="hidden"
              src="/assets/images/animation-present/confetti_albastru.svg"
              alt=""
            />
            <img
              className="hidden"
              src="/assets/images/animation-present/confetti_galben.svg"
              alt=""
            />
            <img
              className="hidden"
              src="/assets/images/animation-present/confetti_galben.svg"
              alt=""
            />
            <img
              className="hidden"
              src="/assets/images/animation-present/confetti_rosu.svg"
              alt=""
            />
            <img
              className="hidden"
              src="/assets/images/animation-present/confetti_rosu.svg"
              alt=""
            />
            <img
              className="hidden"
              src="/assets/images/animation-present/confetti_verde.svg"
              alt=""
            />
          </div>
        ) : (
          <>
            <p
              className={`description ${
                addAnimationClassToChallenge ? "challenge-page-bounce-in" : ""
              }`}
              style={{
                width: challenge.description ? "95%" : "",
              }}
            >
              {challenge.description}
            </p>

            {challenge.media && (
              <CustomVideoPlayer
                src={challenge.media}
                onVideoComplete={handleVideoComplete}
              />
            )}

            <ChallengeFinalizeButton
              onClick={onChallengeCompleted}
              buttonLoading={buttonLoading}
              videoPlaying={!videoCompleted}
              mascotID={challenge.avatar}
              className={`
                ${addHasNotification ? "has_notification" : ""}
                ${
                  addAnimationClassToChallenge ? "challenge-page-bounce-in" : ""
                }
                ${challenge.media ? "has-media" : ""}
              `}
            />

            {colleaguesAlsoCompleted.length ? (
              <div
                className={`completed-by  ${
                  addAnimationClassToChallenge ? "challenge-page-bounce-in" : ""
                }`}
              >
                Completed by {colleaguesAlsoCompleted[0].name}{" "}
                {colleaguesAlsoCompleted.length > 1 ? (
                  <CustomLink
                    to="/challenge/completed-by"
                    state={{ colleagues_list: colleaguesAlsoCompleted }}
                  >
                    and {colleaguesAlsoCompleted.length - 1} more colleague
                    {colleaguesAlsoCompleted.length > 2 && "s"}
                  </CustomLink>
                ) : null}
              </div>
            ) : null}
          </>
        )}
      </div>
    </>
  );
};

const CompletedChallengeElementWithShare = ({
  challenge,
  onShareChallenge,
}) => {
  const [challengesCompleted, setChallengesCompleted] = useState(null);
  const navigator = useCustomNavigate();
  useEffect(() => {
    (async () => {
      let newChallengesCompleted = await getCompletedEvents();

      if (newChallengesCompleted.code === 200) {
        setChallengesCompleted(newChallengesCompleted.challenges_completed);
      } else if (newChallengesCompleted.code === 400) {
        setNotification(newChallengesCompleted.message);
        navigator("/learning");
        return;
      } else if (newChallengesCompleted.code === 403) {
        LogOut();
        setNotification("Please log in once again.");
        navigator("/");
        return;
      } else if (newChallengesCompleted.code === 500) {
        setNotification(newChallengesCompleted.message);
        navigator("/learning");
        return;
      } else {
        setNotification(newChallengesCompleted.message);
        navigator("/learning");
        return;
      }
    })();
  }, []);

  return (
    <>
      <TopMenu
        menuImageName="clear_small"
        menuLink="progress"
        backLink=""
      ></TopMenu>

      <div className="absolute challenge-completed-variant-confetti">
        <img src="/assets/images/confetti-big.png" alt="" />
      </div>

      <PageTitle dimension="big-middle" variant={"blue"}>
        {!challengesCompleted
          ? `Challenge is done!`
          : `${challengesCompleted} Challenges Done!`}
      </PageTitle>

      <div className="absolute challenge-completed-variant-share">
        <h3>Share achievement with colleagues</h3>
        <CustomButton
          onClick={() => {
            onShareChallenge(challenge.achievement._id);
          }}
          style={{ width: "60%" }}
        >
          Share
        </CustomButton>
      </div>

      <div className="absolute challenge-completed-variant-mascot-bottom no-bg">
        <img src="/assets/images/mascot-apple.png" alt="" />
      </div>
    </>
  );
};

const CompletedChallengeElement = ({
  challenge,
  onFeedbackClicked,
  feedback,
}) => {
  const [challengesCompleted, setChallengesCompleted] = useState(null);

  useEffect(() => {
    (async () => {
      let newChallengesCompleted = await getCompletedEvents();

      if (newChallengesCompleted.code === 200) {
        setChallengesCompleted(newChallengesCompleted.challenges_completed);
      } else if (newChallengesCompleted.code === 400) {
        setNotification(newChallengesCompleted.message);
        navigator("/learning");
        return;
      } else if (newChallengesCompleted.code === 403) {
        LogOut();
        setNotification("Please log in once again.");
        navigator("/");
        return;
      } else if (newChallengesCompleted.code === 500) {
        setNotification(newChallengesCompleted.message);
        navigator("/learning");
        return;
      } else {
        setNotification(newChallengesCompleted.message);
        navigator("/learning");
        return;
      }
    })();
  }, []);
  return (
    <>
      <TopMenu showMenu={false} backLink="progress"></TopMenu>

      <div className="absolute challenge-completed-confetti-wrapper">
        <img src="/assets/images/confetti.png" alt="" />
      </div>

      <PageTitle
        dimension="big-middle"
        //subtitle={`${getUser().challenges_completed} Challenges Done!`}
        subtitle={
          !challengesCompleted
            ? `Challenge is done!`
            : `${challengesCompleted} Challenges Done!`
        }
        subtitle_class="big"
      >
        GREAT JOB!
      </PageTitle>

      <div className="absolute challenge-completed-check-wrapper">
        <div>
          <img src="/assets/images/check.png" alt="" />
        </div>
      </div>

      <ChallengeCompletedRating
        challenge={challenge}
        onFeedbackClicked={onFeedbackClicked}
        feedback={feedback}
      />

      <div className="absolute challenge-completed-invite-wrapper">
        <p>Come back for tommorow's challenge!</p>
      </div>
    </>
  );
};

const CompletedChallengeElementReview = ({
  challenge,
  onFeedbackClicked,
  feedback,
  onBackPressed,
  colleaguesAlsoCompleted,
}) => {
  return (
    <>
      <TopMenu
        showMenu={false}
        overloadBack={onBackPressed}
        backLink="back"
      ></TopMenu>

      <div className="absolute challenge-review-check-wrapper ">
        <div>
          <img src="/assets/images/check.png" alt="" />
        </div>
      </div>

      <div className="absolute challenge-review-info">
        <div className="info">{challenge.description}</div>
        {colleaguesAlsoCompleted.length ? (
          <div className="completed-by">
            Completed by {colleaguesAlsoCompleted[0].name}{" "}
            {colleaguesAlsoCompleted.length > 1 && (
              <CustomLink
                to="/challenge/completed-by"
                state={{
                  colleagues_list: colleaguesAlsoCompleted,
                  back: "review",
                }}
              >
                and {colleaguesAlsoCompleted.length - 1} more colleague
                {colleaguesAlsoCompleted.length > 2 && "s"}
              </CustomLink>
            )}
          </div>
        ) : null}
      </div>

      <ChallengeCompletedRating
        challenge={challenge}
        onFeedbackClicked={onFeedbackClicked}
        feedback={feedback}
      />
    </>
  );
};

const PostCompletedChallengeElement = ({ onReviewPressed, colleaguesAlsoCompleted }) => {
  const [learningContent, setLearningContent] = useState(null);
  const [challengesCompleted, setChallengesCompleted] = useState(null);
  const [congratulationStatus, setCongratulationStatus] = useState({});

  const { addNotification } = useNotifications();

  const navigator = useCustomNavigate();

  useEffect(() => {
    (async () => {
      let newChallengesCompleted = await getCompletedEvents();

      if (newChallengesCompleted.code === 200) {
        setChallengesCompleted(newChallengesCompleted.challenges_completed);
      } else if (newChallengesCompleted.code === 400) {
        setNotification(newChallengesCompleted.message);
        navigator("/learning");
        return;
      } else if (newChallengesCompleted.code === 403) {
        LogOut();
        setNotification("Please log in once again.");
        navigator("/");
        return;
      } else if (newChallengesCompleted.code === 500) {
        setNotification(newChallengesCompleted.message);
        navigator("/learning");
        return;
      } else {
        setNotification(newChallengesCompleted.message);
        navigator("/learning");
        return;
      }
    })();

    (async () => {
      try {
        let newLearningContent = await getLearningArticles(2);

        if (newLearningContent.code === 200) {
          setLearningContent(newLearningContent.articles);
        } else if (newLearningContent.code === 400) {
          addNotification(newLearningContent.message);
        } else if (newLearningContent.code === 403) {
          LogOut();
          setNotification("Please log in once again.");
          navigator("/");
          return;
        } else if (newLearningContent.code === 404) {
          return;
        } else if (newLearningContent.code === 500) {
          addNotification(newLearningContent.message);
        } else {
          addNotification(newLearningContent.message);
        }

        return;
      } catch (err) {
        addNotification("An error has occured while updating the user.");
      }
    })();
  }, [addNotification]);

  const learn_jsx =
    learningContent == null
      ? null
      : learningContent.map((el, i) => {
          return (
            <LearnContentElement key={i} element={el} backLink={"challenge"} />
          );
        });
  return (
    <>
      <PageTitle dimension="small" float="left">
        {!challengesCompleted
          ? `Congratulations!`
          : `${challengesCompleted} challenges done!`}
      </PageTitle>

      <div className="absolute challenge-completed-check-wrapper post-page">
        <div>
          <img src="/assets/images/check.png" alt="" />
        </div>
      </div>

      <ScrollContent className="absolute challenge-post-completed-scroll-content">
        <div className="review" onClick={onReviewPressed}>
          Review
        </div>
        <div className="heading-2">
          Come back to find out tommorow's challenge
        </div>
        <div className="hr"></div>
        <div className="completed-by-title">
          Completed by {colleaguesAlsoCompleted?.length || 0} colleague
          {(colleaguesAlsoCompleted?.length || 0) !== 1 && "s"}!
        </div>
        {colleaguesAlsoCompleted && colleaguesAlsoCompleted.length > 0 ? (
          <div className="completed-by-section">
            <ColleaguesList 
              colleagues={colleaguesAlsoCompleted}
              congratulationStatus={congratulationStatus}
              onCongratsSent={(colleagueId) => {
                setCongratulationStatus(prev => ({
                  ...prev,
                  [colleagueId]: true
                }));
              }}
            />
          </div>
        ) : (
          <div className="completed-by-section empty-state">
            <img src="/assets/images/medal.png" alt="Medal" className="medal-icon" />
            <p>You were the <span className="highlight">first</span> to complete today's challenge</p>
          </div>
        )}
        <div className="logo">
          <img src="/assets/images/head-logo.png" alt="" />
          <br />
          Learn more about micro-health:
        </div>
        {learn_jsx}
      </ScrollContent>
    </>
  );
};
export {
  ChallengeElement,
  CompletedChallengeElement,
  CompletedChallengeElementWithShare,
  PostCompletedChallengeElement,
  CompletedChallengeElementReview,
};

export default function CustomVideoPlayer({ src, onVideoComplete }) {
  const videoRef = useRef(null);
  const [isPaused, setIsPaused] = useState(true);
  const [isEnded, setIsEnded] = useState(false);
  const containerRef = useRef(null);
  const fullscreenButtonRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const video = videoRef.current;

    const handleEnd = () => {
      setIsEnded(true);
      setIsPaused(true);
      if (typeof onVideoComplete === "function") {
        onVideoComplete(); // callback
      }
    };

    video.addEventListener("ended", handleEnd);

    return () => {
      video.removeEventListener("ended", handleEnd);
    };
  }, [onVideoComplete]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new ResizeObserver(() => {
      positionFullScreenButton();
    });

    observer.observe(video);

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleTogglePlay = () => {
    const video = videoRef.current;

    if (video.paused || video.ended) {
      video.play();
      setIsPaused(false);
      setIsEnded(false);
    } else {
      video.pause();
      setIsPaused(true);
    }
  };

  const positionFullScreenButton = () => {
    const video = videoRef.current;
    const fullscreenButton = fullscreenButtonRef.current;

    if (!video || !fullscreenButton) return;

    const containerRect = video.getBoundingClientRect();

    const containerWidth = containerRect.width;
    const containerHeight = containerRect.height;

    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;

    if (videoWidth === 0 || videoHeight === 0) {
      return;
    }

    const videoAspect = videoWidth / videoHeight;
    const containerAspect = containerWidth / containerHeight;

    let renderedWidth, renderedHeight;

    if (videoAspect > containerAspect) {
      renderedWidth = containerWidth;
      renderedHeight = containerWidth / videoAspect;
    } else {
      renderedHeight = containerHeight;
      renderedWidth = containerHeight * videoAspect;
    }
    const horizontalOffset = Math.floor(renderedWidth / 2) - 15;
    const verticalOffset = Math.floor(renderedHeight / 2) - 15;
    fullscreenButton.style.transform = `translate(${horizontalOffset}px, ${verticalOffset}px)`;
  };

  const handleFullscreenToggle = () => {
    if (!isFullscreen) {
      if (containerRef.current.requestFullscreen) {
        containerRef.current.requestFullscreen();
      } else if (containerRef.current.mozRequestFullScreen) {
        // Firefox
        containerRef.current.mozRequestFullScreen();
      } else if (containerRef.current.webkitRequestFullscreen) {
        // Chrome, Safari
        containerRef.current.webkitRequestFullscreen();
      } else if (containerRef.current.msRequestFullscreen) {
        // IE
        containerRef.current.msRequestFullscreen();
      }
      setIsFullscreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE
        document.msExitFullscreen();
      }
      setIsFullscreen(false);
    }
  };
  positionFullScreenButton();

  return (
    <div
      className={`challenge-media-wrapper ${
        isFullscreen ? "video-fullscreen" : ""
      }`}
      ref={containerRef}
    >
      <div
        className={`custom-video-container ${
          isPaused || isEnded ? "dimmed" : ""
        }`}
        onClick={handleTogglePlay}
      >
        <video
          ref={videoRef}
          src={src}
          muted
          className="video-responsive"
          playsInline
          preload="metadata"
        />

        {(isPaused || isEnded) && (
          <img
            src={
              isEnded
                ? "/assets/images/biotweak_replay.png"
                : "/assets/images/biotweak_play.png"
            }
            alt={isEnded ? "Replay" : "Play"}
            className="media-button"
          />
        )}
        <button
          ref={fullscreenButtonRef}
          className="fullscreen-button"
          onClick={(e) => {
            e.stopPropagation();
            handleFullscreenToggle();
          }}
          aria-label={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
        >
          <img
            src={
              isFullscreen
                ? "/assets/images/fullscreen-out.png"
                : "/assets/images/fullscreen-in.png"
            }
            alt={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
          />
        </button>
      </div>
    </div>
  );
}
